import { IUserDashboard } from '@jameel/core/models/';

import { createAction, props } from '@ngrx/store';

export const initDashboard = createAction('[Init dashboard] Init dashboard');

export const initDashboardSuccess = createAction('[Init dashboard success] Init dashboard success', props<{ dashboard: IUserDashboard }>());

export const initDashboardFailure = createAction('[Init dashboard failure] Init dashboard failure', props<{ errors: string }>());
